import React from 'react';
import PropTypes from 'prop-types';
import { graphql, StaticQuery } from 'gatsby';
import { COLORS } from 'compositions/constants/constants';

const PropsTable = props => {
  return (
    <StaticQuery
      query={graphql`
        query propsQuery {
          allComponentMetadata {
            edges {
              node {
                displayName
                props {
                  name
                  docblock
                  type {
                    name
                  }
                  defaultValue {
                    value
                  }
                  required
                }
              }
            }
          }
        }
      `}
      render={data => {
        const filter = data.allComponentMetadata.edges.filter(
          p => p.node.displayName === props.name
        );
        const items = filter[0].node.props || {};
        const propDisplay = items.map((item, i) => {
          return (
            <tr key={i}>
              <td style={{ color: `${COLORS.primary}` }}>{item.name}</td>
              <td>{item.type.name || ''}</td>
              {item.required ? (
                <td style={{ color: `${COLORS.secondary}` }}>required</td>
              ) : (
                <td style={{ color: `${COLORS.disabled}` }}>optional</td>
              )}
              {item.defaultValue ? (
                <td>{item.defaultValue.value}</td>
              ) : (
                <td style={{ color: `${COLORS.disabled}` }}>none</td>
              )}
              {item.docblock ? <td>{item.docblock}</td> : <td />}
            </tr>
          );
        });
        return (
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Type</th>
                <th>Required?</th>
                <th>Default Value</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>{propDisplay}</tbody>
          </table>
        );
      }}
    />
  );
};

PropsTable.propTypes = {
  name: PropTypes.string,
};

export default PropsTable;
